import React from "react";
import './App.css';
import Header from './componentes/header.js';
import Noticias from './componentes/noticias.js';
import Accesos from './componentes/accesos.js';
import Colaboradores from './componentes/colaboradores.js';
import Resultados from "./componentes/resultados.js";
import Clasificaciones from "./componentes/clasificaciones.js";
import Clubs from "./componentes/clubs.js";
import Footer from './componentes/footer.js';
import Privacidad from "./componentes/textos_legales/privacidad.js";
import Cookies from "./componentes/textos_legales/cookies.js";
import FloatingButtons from "./componentes/floatingButtons.js";
import CookieBanner from "./componentes/cookieBanner.js";


// PDFs
import Noreba from "./componentes/noreba.js";
import Reglamentos from "./componentes/reglamentos.js";
import Normas from "./componentes/pdfs/normas.js";
import Centros from "./componentes/pdfs/centros.js";
import Poliza from "./componentes/pdfs/poliza.js";
import Convocatoria from "./componentes/pdfs/convocatoria.js";
import Censo from "./componentes/pdfs/censo.js";
import Modelo from "./componentes/pdfs/modelo.js";
import Actas from "./componentes/pdfs/actas.js";
import ComiteCompeticion from "./componentes/pdfs/comiteCompeticion.js";
import ComiteApelacion from "./componentes/pdfs/comiteApelacion.js";
import Circulares from "./componentes/pdfs/circulares.js";
import DocumentosInteres from "./componentes/pdfs/documentosInteres.js";

import { Routes, Route } from "react-router-dom";

function Home() {
  return (
    <>
      <Header />
      <Noticias />
      <Accesos />
      <Colaboradores />
      <Footer />
      <FloatingButtons />
      <CookieBanner />
    </>
  );
}

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />

      {/* Secciones principales */}
      <Route path="/clubs" element={<><Header /><Clubs /><Footer /><FloatingButtons /></>} />
      <Route path="/resultados" element={<><Header /><Resultados /><Footer /><FloatingButtons /></>} />
      <Route path="/clasificaciones" element={<><Header /><Clasificaciones /><Footer /><FloatingButtons /></>} />

      {/* === Normativa === */}
      <Route path="/reglamentos" element={<><Header /><Reglamentos /><Footer /><FloatingButtons /></>} />
      <Route path="/noreba" element={<><Header /><Noreba /><Footer /><FloatingButtons /></>} />
      <Route path="/circulares" element={<><Header /><Circulares /><Footer /><FloatingButtons /></>} />
      <Route path="/doc_interes" element={<><Header /><DocumentosInteres /><Footer /><FloatingButtons /></>} />

      {/* === Seguro Deportivo === */}
      <Route path="/normas" element={<><Header /><Normas /><Footer /><FloatingButtons /></>} />
      <Route path="/centros" element={<><Header /><Centros /><Footer /><FloatingButtons /></>} />
      <Route path="/poliza" element={<><Header /><Poliza /><Footer /><FloatingButtons /></>} />

      {/* === Elecciones === */}
      <Route path="/convocatoria" element={<><Header /><Convocatoria /><Footer /><FloatingButtons /></>} />
      <Route path="/censo" element={<><Header /><Censo /><Footer /><FloatingButtons /></>} />
      <Route path="/modelo" element={<><Header /><Modelo /><Footer /><FloatingButtons /></>} />
      <Route path="/actas" element={<><Header /><Actas /><Footer /><FloatingButtons /></>} />

      {/* === Competiciones === */}
      <Route path="/comite-competicion" element={<><Header /><ComiteCompeticion /><Footer /><FloatingButtons /></>} />
      <Route path="/comite-apelacion" element={<><Header /><ComiteApelacion /><Footer /><FloatingButtons /></>} />

      {/* Legales */}
      <Route path="/privacidad" element={<Privacidad />} />
      <Route path="/cookies" element={<Cookies />} />

      {/* 404 */}
      <Route path="*" element={<div style={{ padding: 24 }}>Página no encontrada</div>} />
    </Routes>
  );
}
